/**
 * Account avatar URL for header / menus.
 * Host dashboard photos live on `users.hostProfile.imageUrl`; the public header
 * historically only read Firebase Auth `photoURL`, so the two views drifted.
 */
export function resolveAccountPhotoUrl(params: {
  hostProfileImageUrl?: string | null;
  firestorePhotoURL?: string | null;
  authPhotoURL?: string | null;
}): string | null {
  const host = (params.hostProfileImageUrl || "").trim();
  if (host) {
    return host;
  }
  const fromDoc = (params.firestorePhotoURL || "").trim();
  if (fromDoc) {
    return fromDoc;
  }
  const fromAuth = (params.authPhotoURL || "").trim();
  return fromAuth || null;
}

export function hostProfileImageUrlFromUserData(
  data?: Record<string, unknown> | null,
): string | null {
  if (!data || typeof data.hostProfile !== "object" || !data.hostProfile) {
    return null;
  }
  const imageUrl = (data.hostProfile as Record<string, unknown>).imageUrl;
  return typeof imageUrl === "string" && imageUrl.trim() ? imageUrl.trim() : null;
}
